const sessionPerDayChart = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false, // Hide the legend
    },
    title: {
      display: false,
    },
    tooltip: {
      mode: "index",
      intersect: false,
    },
  },
  scales: {
    x: {
      stacked: true,
      categoryPercentage: 0.3, // make bars thin
      barPercentage: 0.5, // make bars thin
      grid: {
        display: false,
      },
      ticks: {
        font: {
          family: "Poppins, sans-serif",
          size: 11,
        },
        color: "#666",
      },
    },
    y: {
      stacked: true,
      grid: {
        display: true,
        color: "#E0E0E0",
        borderDash: [4, 4],
      },
      ticks: {
        font: {
          family: "Poppins, sans-serif",
          size: 11,
        },
        color: "#666",
        stepSize: 1, // optional: make grid steps smaller
      },
    },
  },
};

const deliveryTrendChart = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: "bottom",
      align: "end",
      labels: {
        boxWidth: 12,
        boxHeight: 12,
        usePointStyle: true,
        pointStyle: "rectRounded",
        padding: 20,
        font: {
          family: "Poppins, sans-serif",
          size: 12,
        },
        color: "#666",
      },
    },
    tooltip: {
      mode: "index",
      intersect: false,
    },
  },
  scales: {
    x: {
      stacked: true,
      grid: {
        display: false,
      },
      ticks: {
        font: {
          family: "Poppins, sans-serif",
          size: 11,
        },
        color: "#666",
      },
    },
    y: {
      stacked: true,
      grid: {
        display: true,
        color: "#E0E0E0",
        borderDash: [4, 4],
      },
      ticks: {
        font: {
          family: "Poppins, sans-serif",
          size: 11,
        },
        color: "#666",
        stepSize: 1,
      },
    },
  },
};

export { sessionPerDayChart, deliveryTrendChart };
